import React, { useEffect, useRef, useState } from 'react'
import CustomizedDialogs from '../../../common/CustomizedDialogs'
import { Box, Paper, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import MButton from '../../../common/MButton'
import { showErrorAlert, showSuccessAlert, updateLoadingScreen } from '../../../redux/Actions'
import { useDispatch, useSelector } from 'react-redux'
import UnutilizedPytInfo from './UnutilizedPytInfo'
import { bookingPaymentUnutilized, bookingQrBkgDetailsInsertUpdate, generateQRRefund, getConsumedList } from '../../../redux/Booking/BookingActions'
import '../../../style/modal/UnutilizedPyt.scss'
import { generateChecksum } from '../../../utils/helpers'
import { QRBaseUrl } from '../../../assets/extra/_httpServices'
import axios from 'axios'
import Information from '../Information'
const UnutilizedPyt = (props) => {
    const { open = false, titleText = '', data = [], bkgDeatails = {}, bkgTotal = {}, onClose = () => { }, handleGenerateTicket = () => { }, tripTotalAmt, selectedSeat = [] } = props
    const timerRef = useRef(null);
    const abortControllerRef = useRef(null);
    const dispatch = useDispatch()
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;
    const [pytDetails, setPytDetails] = useState({
        consumedList: [],
        selConsumed: [],
        tableData: []
    })
    const [openModal, setOpenModal] = useState({
        id: 0,
        open: false,
        data: {}
    })

    useEffect(() => {
        if (open && data?.length !== 0) {
            fetchConsumedData(data)
        }
    }, [open, data])
    const columnDef = [
        { headerName: '', field: 'radioBtn', headerSx: { textAlign: 'left' } },
        { headerName: 'Provider', field: 'Provider', headerSx: { textAlign: 'left' } },
        { headerName: 'Business', field: 'Business', headerSx: { textAlign: 'left' } },
        { headerName: 'Payment\nType', field: 'PaymentType', headerSx: { textAlign: 'left' } },
        { headerName: 'Mode', field: 'Mode', headerSx: { textAlign: 'left' } },
        { headerName: 'Mode\nValue', field: 'ModeValue', headerSx: { textAlign: 'left' } },
        { headerName: 'Order\nID', field: 'OrderID', headerSx: { textAlign: 'left' } },
        { headerName: 'Transaction\nID', field: 'TransactionID', headerSx: { textAlign: 'left' } },
        { headerName: 'Tran\nInitiated On', field: 'TransInitiate', headerSx: { textAlign: 'left' } },
        { headerName: 'Tran\nCompleted On', field: 'TranCompleted', headerSx: { textAlign: 'left' } },
        { headerName: 'Total\nAmount', field: 'TotalAmt', headerSx: { textAlign: 'right' } },
        { headerName: 'Txn\nStatus', field: 'TxnStatus', headerSx: { textAlign: 'left' } },
    ]

    const fetchConsumedData = (payArr = []) => {
        const body = {
            vertical: "BUS",
            application: "CRS",
            companyId: bkgDeatails?.tripDetails?.CompanyID,
            agentId: 0,
            agentUserId: 0,
            branchId: 0,
            branchUserId: 0,
            deviceType: "WEB",
            deviceId: ""
        }
        Promise.all([
            dispatch(getConsumedList(body)),
            dispatch(getConsumedList({ ...body, deviceType: 'android' }))
        ]).then((res) => {
            if (res?.[0]?.data?.isSuccess && res?.[1]?.data?.isSuccess) {
                let refundData = [...(res?.[0]?.data?.data || []), ...(res?.[1]?.data?.data || [])]
                let newData = payArr.map((obj) => {
                    let checkRefund = refundData.filter((item) => (item?.orderId === obj?.OrderID))
                    if (checkRefund?.length !== 0) {
                        return { ...obj, ...checkRefund?.[0] }
                    }
                    return { ...obj, }
                })
                setPytDetails((prev) => ({
                    ...prev,
                    consumedList: res?.data?.data,
                    selConsumed: newData?.length > 0 ? [newData?.[0]] : [],
                    tableData: newData
                }))

            } else {
                dispatch(showErrorAlert(res?.data?.error))
            }
        })

    }
    const handleRefund = () => {
        const body = {
            checksum: '',
            orderId: pytDetails?.selConsumed?.[0]?.OrderID,
        }
        let checksum = generateChecksum(body)
        dispatch(generateQRRefund({ ...body, checksum })).then((res) => {
            if (res?.data?.isSuccess) {
                setOpenModal((prev) => ({
                    ...prev,
                    id: 1,
                    open: true,
                    data: res?.data?.data?.orderId || {}
                }))
                handleRefundStatus(res?.data?.data?.orderId)
            } else {
                dispatch(showErrorAlert(res?.data?.error?.description))
            }
        }).catch((err) => {
            dispatch(showErrorAlert("Something went wrong while processing the refund."));
        });

    }


    const handleRefundStatus = async (orderId) => {
        try {
            abortControllerRef.current = new AbortController();
            const res = await axios.get(`${QRBaseUrl}/v1/orders/${orderId}/refund/status`, {
                signal: abortControllerRef.current.signal,
            })
            if (res?.data?.isSuccess) {
                if (res?.data?.data?.status === "PAYMENT_PENDING" || res?.data?.data?.status === 'PAYMENT_INITIATED') {
                    handleStatusUpdated(res?.data?.data)
                    timerRef.current = setTimeout(() => {
                        handleRefundStatus(orderId)
                    }, 3000);
                } else if (res?.data?.data?.status === "PAYMENT_FAILURE") {
                    dispatch(showErrorAlert('Payment Failed'))
                    handleStatusUpdated(res?.data?.data)
                } else if (res?.data?.data?.status === "PAYMENT_SUCCESS") {
                    handleStatusUpdated(res?.data?.data)
                }
            } else {
                handleStopPayment()
                dispatch(showErrorAlert(res?.data?.error))
            }
        } catch (error) {
            if (error.name === 'CanceledError') {
                console.log("API request canceled");
            } else {
                console.error("Error fetching QR:", error);
            }
        }
    };


    const handleStatusUpdated = (statusData = {}) => {
        const body = {
            intorderid: statusData?.orderId,
            decamount: 0,
            decpgcharge: 0,
            decpgamount: 0,
            strstatus: '',
            strmerchanttxnid: '',
            strpgtxnid: '',
            dtstatustime: '01-01-0001 00:00:00',
            intcompanyid: bkgDeatails?.tripDetails?.CompanyID,
            intentityid: userDetails.AgentID,
            strentitytype: 'A',
            BusinessVerticleId: 1,
            paymentproducttypeid: 9,
            entityPaymentid: 0,
            userid: userDetails.AgentUserID,
            qrUTRNumber: '',
            RechargeStatus: '',
            transferfee: 0,
            strpgname: '',
            mobileno: bkgDeatails?.phoneNumber,
            intbranchid: 0,
            refStatus: statusData.status,
            refStatusTime: statusData.statusTime,
            refUserID: userDetails.AgentUserID,
        }
        dispatch(bookingQrBkgDetailsInsertUpdate(body)).then((res) => {
            if (res?.data?.status) {
                if (statusData?.status === 'PAYMENT_SUCCESS') {
                    handleStopPayment()
                    dispatch(showSuccessAlert(`Your refund has been processed successfully! Order ID: ${statusData?.orderId}`))
                    onClose()
                } else if (statusData?.status === 'PAYMENT_PENDING' || statusData?.status === 'PAYMENT_INITIATED') {

                } else {
                    handleStatusUpdated('Payment Failed')
                    handleStopPayment()
                }
                return
            } else {
                handleStatusUpdated(res?.data?.Message)
                handleStopPayment()
            }
        })
    }
    const handleStopPayment = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }

        // Abort any ongoing API call
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();  // This cancels axios call
            abortControllerRef.current = null;
        }
        setOpenModal((prev) => ({
            ...prev,
            id: 0,
            open: false,
            data: {}
        }))

    };
    return (
        <CustomizedDialogs
            open={open}
            titleText={titleText}
            width={'95%'}
            height={'auto'}
            onClose={onClose}
            padding={'0px'}
        >
            <Box className='unutilizedPyt-container scrollBlueV6' maxHeight={'78vh'} sx={{
                overflowY: 'auto',
            }}>
                <Box sx={{
                    padding: "12px 16px"

                }}>

                    <TableContainer component={Paper} className='scrollBlueV6' sx={{
                        boxShadow: 'none', border: '1px solid #0000001A',

                    }}>
                        <Table stickyHeader size="small" aria-label="a dense table"
                            sx={{
                                '.MuiTableCell-root': {
                                    padding: '12px 4px'
                                },
                                '.MuiTableCell-root:first-of-type': {
                                    pl: '12px',
                                },
                                '.MuiTableCell-root:last-of-type': {
                                    pr: '12px',
                                },
                            }}
                        >
                            <TableHead style={{ position: `sticky`, top: `0`, zIndex: '3' }}>
                                <TableRow>
                                    {columnDef.map((col, index) => (
                                        <TableCell key={`UnutilizedPyt-Table-header-${index}`}
                                            sx={{
                                                ...col?.headerSx,
                                                backgroundColor: '#E5F3FF',
                                                color: '#202020',
                                                fontWeight: 600,
                                                fontStyle: 'SemiBold',
                                                fontSize: '14px',
                                                lineHeight: '20px',
                                                letterSpacing: '0%',
                                                verticalAlign: 'top',
                                                whiteSpace: 'nowrap'

                                            }}
                                        >{col?.field === 'radioBtn' ?
                                            <Radio disabled={true} />
                                            : col?.headerName}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {pytDetails?.tableData?.length > 0 ? pytDetails?.tableData?.map((obj) => (
                                    <TableRow
                                        sx={{
                                            '&:last-child td, &:last-child th': { borderBottom: 'none' },
                                        }}
                                    >
                                        {columnDef?.map((col) => {
                                            return (
                                                col?.field === 'radioBtn' ?
                                                    <TableCell sx={{
                                                        ...col?.headerSx,
                                                        whiteSpace: 'nowrap',

                                                    }}>
                                                        <Box sx={{ display: 'flex', alignItems: "start" }}>
                                                            <Radio checked={obj.OrderID === pytDetails?.selConsumed?.[0]?.OrderID}
                                                                onChange={() => {
                                                                    setPytDetails((prev) => ({
                                                                        ...prev,
                                                                        selConsumed: [obj]
                                                                    }))
                                                                }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    :
                                                    <TableCell
                                                        sx={{
                                                            ...col?.headerSx,
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >{obj?.[col?.field] || ''}</TableCell>
                                            )
                                        })}
                                    </TableRow>
                                )) :
                                    <TableRow>
                                        <TableCell colSpan={columnDef?.length}>No Record</TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

                <Box className='modalBottomBtnSection' >
                    <Box sx={{ display: 'flex', gap: '6px', justifyContent: 'end' }}>
                        <MButton variant='outlined' btnName="Cancel" onClick={onClose} />
                        <MButton btnName="Refund"
                            disabled={pytDetails?.selConsumed?.length === 0 || pytDetails?.selConsumed?.[0]?.isRefundable !== true}
                            onClick={handleRefund}
                        />
                        <MButton btnName="Book"
                            disabled={pytDetails?.selConsumed?.length === 0}
                            onClick={() => {
                                if (pytDetails?.selConsumed?.length === 0) {
                                    dispatch(showErrorAlert('Select Order Id'))
                                } else if (Math.abs(Number(pytDetails?.selConsumed?.[0]?.TotalAmt) - Number(Number(bkgTotal?.grandTotal)?.toFixed(2))) > 2) {
                                    dispatch(showErrorAlert('Please ensure the total booking amount matches the unutilized payment amount'))
                                } else {
                                    setOpenModal((prev) => ({
                                        ...prev,
                                        id: 2,
                                        open: true,
                                        data: {}
                                    }))

                                }
                            }}
                        />
                    </Box>
                </Box>
                {openModal?.open &&
                    <>

                        {openModal?.id === 1 && <UnutilizedPytInfo open={openModal?.id === 1} data={openModal?.data} />}
                        {openModal.id === 2 &&
                            <Information open={openModal.id === 2} bkgDeatails={bkgDeatails} tripTotalAmt={tripTotalAmt}
                                seat={selectedSeat.map((obj) => (obj.SeatLabel)).join(',')}
                                onClose={() => {
                                    setOpenModal((prev) => ({
                                        ...prev,
                                        id: 0,
                                        open: false,
                                        data: {}
                                    }))
                                }}
                                handleGenerateTicket={() => {
                                    onClose()
                                    handleGenerateTicket(pytDetails?.selConsumed?.[0]?.OrderID, pytDetails?.selConsumed?.[0]?.pgTxnId)
                                }}
                            />
                        }
                    </>
                }
            </Box>
        </CustomizedDialogs>
    )
}

export default UnutilizedPyt